import React from 'react';
import { compose, withProps } from 'recompose';
import { withLabel } from '@/se/components/Label';
import ReportRecipients from '../../sensor/ReportRecipients';
import SelectInput from '@/se/components/inputs/SelectInput';
import { Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { useDebugMode } from '@/hooks/useDebugMode';
import { hoursOptions } from '@/util/timeOptions';

const weeklyDayOptions = [
  { value: '1', label: 'Monday' },
  { value: '2', label: 'Tuesday' },
  { value: '3', label: 'Wednesday' },
  { value: '4', label: 'Thursday' },
  { value: '5', label: 'Friday' },
  { value: '6', label: 'Saturday' },
  { value: '7', label: 'Sunday' },
];

const monthlyDayOptions = Object.fromEntries(Array.from({ length: 28 }, (_, i) => [i + 1, String(i + 1)]));

const Recipients = compose(withLabel('Recipients'), withProps({ showChannelBadges: true }))(ReportRecipients);

const DaySelect = compose(withLabel('Day'))(SelectInput);
const HourSelect = compose(withLabel('Hour'))(SelectInput);
const DayOfMonthSelect = compose(withLabel('Day of month'))(SelectInput);

const AnalyticsConfigInputV1 = ({ value, onChange }: any) => {
  const { canBypassPermissions } = useDebugMode();
  const val = value || {};

  const update = (field: string, v: any) => {
    onChange({ ...val, [field]: v });
  };

  return (
    <Box display="flex" flexDirection="column" style={{ gap: 24, width: '100%' }}>
      <Box>
        <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8 }}>
          Weekly Report
        </Typography>
        <Recipients
          name="weeklyReportRecipients"
          value={val.weeklyReportRecipients}
          onChange={(v: any) => update('weeklyReportRecipients', v)}
        />
        {canBypassPermissions && (
          <Box display="flex" style={{ gap: 16 }} flexWrap="wrap">
            <Box flex="1" minWidth={140}>
              <DaySelect
                name="weeklyReportDay"
                value={val.weeklyReportDay ?? 1}
                onChange={(v: any) => update('weeklyReportDay', v)}
                options={weeklyDayOptions}
                isClearable={(val.weeklyReportDay ?? 1) !== 1}
              />
            </Box>
            <Box flex="1" minWidth={140}>
              <HourSelect
                name="weeklyReportHour"
                value={val.weeklyReportHour ?? 8}
                onChange={(v: any) => update('weeklyReportHour', v)}
                options={hoursOptions}
                isClearable={(val.weeklyReportHour ?? 8) !== 8}
              />
            </Box>
          </Box>
        )}
      </Box>

      <Box>
        <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8 }}>
          Monthly Report
        </Typography>
        <Recipients
          name="monthlyReportRecipients"
          value={val.monthlyReportRecipients}
          onChange={(v: any) => update('monthlyReportRecipients', v)}
        />
        {canBypassPermissions && (
          <Box display="flex" style={{ gap: 16 }} flexWrap="wrap">
            <Box flex="1" minWidth={140}>
              <DayOfMonthSelect
                name="monthlyReportDay"
                value={val.monthlyReportDay ?? 1}
                onChange={(v: any) => update('monthlyReportDay', v)}
                options={monthlyDayOptions}
                isClearable={(val.monthlyReportDay ?? 1) !== 1}
              />
            </Box>
            <Box flex="1" minWidth={140}>
              <HourSelect
                name="monthlyReportHour"
                value={val.monthlyReportHour ?? 8}
                onChange={(v: any) => update('monthlyReportHour', v)}
                options={hoursOptions}
                isClearable={(val.monthlyReportHour ?? 8) !== 8}
              />
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AnalyticsConfigInputV1;
